import { useContentOverflow } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'

import * as styles from './TaskPrioritySelectItemContent.module.css'

function TaskPrioritySelectItemContent({ value }) {
  const { label, labelBackgroundColor, labelTextColor } = value

  const { overflow: textOverlfow, setContentOverflowRef } = useContentOverflow()

  return (
    <FloatingTooltip content={label} disabled={!textOverlfow}>
      <div
        className={styles.label}
        ref={setContentOverflowRef}
        style={{
          '--list-item-label-bg-color': labelBackgroundColor,
          '--list-item-label-text-color': labelTextColor,
        }}
      >
        {label}
      </div>
    </FloatingTooltip>
  )
}

export default TaskPrioritySelectItemContent
